var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, PICInput, booleanDecoder, numberDecoder, PICLoadPage } from '../Internals';
import { html, css } from 'lit';
import { property, query, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
let PICSlider = class PICSlider extends PICInput {
    constructor() {
        super(...arguments);
        this.step = 1;
        this.dualMode = false;
    }
    get submitValue() {
        if (this.dualMode)
            return `${this.inlow.value}^${this.inmax.value}`;
        return this.inlow.value;
    }
    static get styles() {
        const defaultStyle = css `
        :host{
            --pic-sliderUnselectedColor: var(--pic-primaryMediumColor);
            --pic-sliderSelectedColor: var(--pic-primaryColor);
            --pic-sliderTrackColor: var(--pic-primaryMediumColor);
            --pic-sliderTrackOORColor: var(--pic-onSurfaceMediumColor);
            --pic-sliderThumbColor: var(--pic-primaryColor);
            --pic-sliderHoverBGColor: var(--primaryHoverColor);
            --pic-nosliders: 1;
            /* Native chrome (e.g. any remaining UA-styled bits of the range
               input) should still follow the current theme's palette. */
            color-scheme: var(--pic-colorScheme, light);
        }

        .pic-inputLabel-default {
            z-index: 1;
        }
        .container.low{
            height: 66px;
        }
        .container.medium{
            height: 58px;
        }
        .container.high{
            height: 36px;   
        }
        .container input[type=range] {
            position: absolute;
            left: 0;
        }
        .container input[type=range]:disabled::-webkit-slider-runnable-track, .container input[type=range]:disabled::-webkit-slider-thumb {
            cursor: default;
        }
        .container input[type=range].low{
            bottom: -9px;
            height: var(--pic-densityLowInputHeight);
        }
        input[type=range].medium {
            bottom: -8px;
            height: var(--pic-densityMediumInputHeight);             
        }
        input[type=range].high {
            bottom: -3px;
            height: var(--pic-densityHighInputHeight);           
        }        

        input[type=range] {
            -webkit-appearance: none;
            width: calc(100% - ((47px * var(--pic-nosliders, 1)) + 4px));
            padding-left: 47px;
            color: var(--pic-sliderTrackColor);
            background-color: transparent;
            border: unset;
        }
        
        input[type=range]:focus::-webkit-slider-runnable-track {
            background: var(--pic-sliderTrackColor);
            color: var(--pic-sliderTrackColor);
            border-radius: 10px;
        }
        
        input[type=range]:focus::-ms-fill-lower {
            background: var(--pic-sliderTrackOORColor);
            color:  var(--pic-sliderTrackOORColor);
        }

        input[type=range]:focus::-ms-fill-upper {
            background: var(--pic-sliderTrackOORColor);
            color:  var(--pic-sliderTrackOORColor);
        }

        input[type=range]::-webkit-slider-runnable-track {
            width: 100%;
            height: 5px;
            cursor: pointer;
            animate: 0.2s;
            background: var(--pic-sliderTrackColor);
            color:  var(--pic-sliderTrackColor);
            border-radius: 1px;
            box-shadow: none;
            border: 0;
            border-radius: 10px;
        }
        input[type=range]::-webkit-slider-thumb {
            z-index: 2;
            position: relative;
            box-shadow: 0px 0px 0px #000;
            border: 1px solid var(--pic-sliderThumbColor);
            height: 18px;
            width: 18px;
            border-radius: 25px;
            background: var(--pic-sliderThumbColor);;
            cursor: pointer;
            -webkit-appearance: none;
            margin-top: -7px;
        }
        .container {
            position: relative;
        }
        .container .disp{
            position: absolute;   
            z-index: 1;
            border-radius: 4px;
            padding: 4px;
            text-align: center;
            background-color: rgba(0, 0, 0, 0.12);
        }        
        .container .disp.disabled{
            color: var(--pic-onSurfaceDisabledColor);
        }
        .container .disp.lowerboundary{
            left: 2px;
        }
        .container .disp.maxboundary{
            right: 2px;
        }
        .container .disp.low{
            bottom: 0px;
            width: 36.5px;
        }
        .container .disp.medium{
            bottom: 0px;
            width: 36.5px;
            line-height: 18px;
            font-size: 14px;
        }
        .container .disp.high{
            bottom: 0px;
            width: 36.5px;
            line-height: 12px;
            font-size: 12px;
        }

        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.dualMode) {
            this.innerlow = this.value.split('^')[0];
            this.innermax = this.value.split('^')[1];
        }
        else {
            this.innerlow = this.value;
        }
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this.initValue_ = this.submitValue;
        this.onRangeChange(this.inlow, (e) => { this.innerValueChangeHandler(e, 'low'); });
        if (this.dualMode) {
            this.style.setProperty('--pic-nosliders', '2');
            this.onRangeChange(this.inmax, (e) => { this.innerValueChangeHandler(e, 'max'); });
        }
        this.sliderColorHandler();
    }
    onRangeChange(relm, listener) {
        let inputHasNeverFired = true;
        let rangeVal = { current: undefined, mostRecent: undefined };
        relm.addEventListener('input', function (e) {
            inputHasNeverFired = false;
            rangeVal.current = e.target.value;
            if (rangeVal.current !== rangeVal.mostRecent) {
                listener(e);
            }
            rangeVal.mostRecent = rangeVal.current;
        });
        relm.addEventListener('change', function (e) {
            if (inputHasNeverFired) {
                listener(e);
            }
        });
    }
    innerValueChangeHandler(e, field) {
        if (field == 'low') {
            this.innerlow = e.target.value;
            if (this.dualMode)
                if (Number(this.inmax.value) <= Number(this.innerlow)) {
                    this.inmax.value = this.innerlow;
                    this.innermax = this.inmax.value;
                }
        }
        else {
            this.innermax = e.target.value;
            if (Number(this.inlow.value) >= Number(this.innermax)) {
                this.inlow.value = this.innermax;
                this.innerlow = this.inlow.value;
            }
        }
        this.sliderColorHandler();
        this.requestUpdate();
    }
    sliderColorHandler() {
        if (this.disabled_) {
            this.style.setProperty('--pic-sliderUnselectedColor', '#a6a6a6');
            this.style.setProperty('--pic-sliderSelectedColor', '#666666');
            this.style.setProperty('--pic-sliderThumbColor', '#666666');
        }
        let p1 = (Number(this.innerlow) - this.min) / (this.max - this.min) * 100;
        if (!this.dualMode) {
            this.style.setProperty('--pic-sliderTrackColor', `linear-gradient(to right, var(--pic-sliderSelectedColor) 0%, var(--pic-sliderSelectedColor) ${p1}%, var(--pic-sliderUnselectedColor) ${p1}%, var(--pic-sliderUnselectedColor) 100%)`);
        }
        else {
            let p2 = (Number(this.innermax) - this.min) / (this.max - this.min) * 100;
            this.style.setProperty('--pic-sliderTrackColor', `linear-gradient(to right, var(--pic-sliderUnselectedColor) 0%, var(--pic-sliderUnselectedColor) ${p1}%, var(--pic-sliderSelectedColor) ${p1}%, var(--pic-sliderSelectedColor) ${p2}%, var(--pic-sliderUnselectedColor) ${p2}%, var(--pic-sliderUnselectedColor) 100%)`);
        }
    }
    focus() {
        this.inlow.focus();
    }
    innerFocusHandler(e) {
        var _a;
        if (document.activeElement == this) {
            // still focused, do nothing
            return;
        }
        else if (document.activeElement instanceof PICLoadPage) {
            if (((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.activeElement) == null) {
                // not focused, handle here
                super.changeHandler(e);
                return;
            }
            else {
                // still focused, do nothing
                return;
            }
        }
        else {
            //not focused, handle here
            super.changeHandler(e);
            return;
        }
    }
    getDispMap(iBound) {
        return {
            disp: true,
            'pic-body1': true,
            [this.density]: true,
            disabled: this.disabled_,
            [iBound]: true,
        };
    }
    render() {
        this.setComponentInlineStyle();
        return html `
            ${this.renderCSS(true)}
            <div style=${styleMap(this.getContainerStyle())} class=${classMap(this.classAdder(this.getContainerClassMap(), this.density))}>
                <label class=${classMap(this.classAdder(this.getInputLabelClass(), 'inner-inputLabel'))} for=${this.id_ + '_inner'}>${this.label}</label>
                <div class=${classMap(this.getDispMap('lowerboundary'))}>${this.innerlow}</div>
                <input 
                    name="${this.id_}"
                    id="${this.id_}_inner"
                    class="inner_low ${this.density}"
                    type="range" 
                    ?disabled=${this.disabled_}
                    ?readonly=${this.readonly_}
                    tabindex=${this.readonly_ ? -1 : 1}
                    step=${this.step}
                    min=${this.min} 
                    max=${this.max} 
                    value=${this.innerlow} 
                    @focusout=${this.innerFocusHandler}
                />
                ${this.dualMode ? html `<input
                    name="${this.id_}max"
                    id="${this.id_}_inner_max"
                    class="inner_max ${this.density}"
                    type="range" 
                    ?disabled=${this.disabled_}
                    ?readonly=${this.readonly_}
                    tabindex=${this.readonly_ ? -1 : 1}
                    step=${this.step}
                    min=${this.min} 
                    max=${this.max} 
                    value=${this.innermax} 
                    @focusout=${this.innerFocusHandler}
                />
                <div class=${classMap(this.getDispMap('maxboundary'))}>${this.innermax}</div>
                ` : ''}
            </div>
            ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : ''}
        `;
    }
};
__decorate([
    query('.inner-low')
], PICSlider.prototype, "inputField", void 0);
__decorate([
    property()
], PICSlider.prototype, "min", void 0);
__decorate([
    property()
], PICSlider.prototype, "max", void 0);
__decorate([
    property({ converter: numberDecoder })
], PICSlider.prototype, "step", void 0);
__decorate([
    property({ converter: booleanDecoder })
], PICSlider.prototype, "dualMode", void 0);
__decorate([
    query('.inner_low')
], PICSlider.prototype, "inlow", void 0);
__decorate([
    query('.inner_max')
], PICSlider.prototype, "inmax", void 0);
__decorate([
    state()
], PICSlider.prototype, "innerlow", void 0);
__decorate([
    state()
], PICSlider.prototype, "innermax", void 0);
PICSlider = __decorate([
    customElement('pic-slider')
], PICSlider);
export { PICSlider };
//# sourceMappingURL=PICSlider.js.map